export const SponsorsData = [
    {
        title: "Santa Rosa Pharmacy",
        alt: "Santa Rosa Pharmacy Logo",
        source: "/images/sponsors/srrx.jpg",
        url: "https://santarosarx.com/",
        className: "sponsors-image",
    },

    {
        title: "Hema Biologics",
        alt: "Hemabiologics Logo",
        source: "/images/sponsors/hema-biologics.png",
        url: "https://hemabio.com/",
        className: "sponsors-image dark-logo",
    },

    {
        title: "Bayer",
        alt: "bayer logo",
        source: "/images/sponsors/bayer.png",
        url: "https://www.bayer.com/en/",
        className: "sponsors-image",
    },

    {
        title: "Novo Nordisk",
        alt: "Novo Nordisk logo",
        source: "/images/sponsors/novo-nordisk.png",
        url: "https://www.novonordisk.com/",
        className: "sponsors-image",
    },

    {
        title: "Octapharma",
        alt: "Octapharma logo",
        source: "/images/sponsors/octapharma.png",
        url: "https://www.octapharmaplasma.com/",
        className: "sponsors-image",
    },

    {
        title: "Medexus Pharma",
        alt: "medexus logo",
        source: "/images/sponsors/medexus.png",
        url: "https://www.medexus.com/en_US",
        className: "sponsors-image",
    },

    {
        title: "InfuCareRX",
        alt: "InfuCareRX logo",
        source: "/images/sponsors/infucarerx.png",
        url: "https://infucarerx.com/",
        className: "sponsors-image",
    },

    {
        title: "Sanofi",
        alt: "Sanofi logo",
        source: "/images/sponsors/sanofi.png",
        url: "https://www.sanofi.com/en",
        className: "sponsors-image dark-logo",
    },

    {
        title: "Rare Patient Voice",
        alt: "rare patient voice logo",
        source: "/images/sponsors/rare-patient-voice.jpg",
        url: "https://rarepatientvoice.com/",
        className: "sponsors-image",
    },

    {
        title: "Scholastic",
        alt: "scholastic logo",
        source: "/images/sponsors/scholastic.png",
        url: "https://www.scholastic.com/home",
        className: "sponsors-image",
    },

    {
        title: "Sockathon",
        alt: "sockathon logo",
        source: "/images/sponsors/sockathon.png",
        url: "https://try.sockathon.com",
        className: "sponsors-image",
    },

    {
        title: "EJ Pretty",
        alt: "ej pretty logo",
        source: "/images/sponsors/ej-pretty.png",
        url: "https://www.ejprettychicago.com/",
        className: "sponsors-image",
    },

    {
        title: "UNREAL",
        alt: "unreal logo",
        source: "/images/sponsors/unreal.png",
        url: "https://unrealsnacks.com",
        className: "sponsors-image",
    },
]